// frontend/src/api/email_autoresponders.ts
/**
 * Tenant autoresponder (vacation auto-reply) API.
 *
 * Backed by /api/email/autoresponders and
 * /api/email/mailboxes/{id}/autoresponder. All calls go through
 * fetchAPI so the §9 resilience contract applies.
 */
import { fetchAPI } from './client';

const API_BASE_URL = '/api';

export interface Autoresponder {
  id: number;
  mailbox_id: number;
  user_id: number;
  subject: string;
  body: string;
  is_enabled: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface AutoresponderUpsertBody {
  subject: string;
  body: string;
  is_enabled: boolean;
}

export const emailAutorespondersAPI = {
  list(): Promise<Autoresponder[]> {
    return fetchAPI<Autoresponder[]>(`${API_BASE_URL}/email/autoresponders`);
  },

  get(mailboxId: number): Promise<Autoresponder> {
    return fetchAPI<Autoresponder>(
      `${API_BASE_URL}/email/mailboxes/${mailboxId}/autoresponder`,
    );
  },

  upsert(mailboxId: number, body: AutoresponderUpsertBody): Promise<Autoresponder> {
    return fetchAPI<Autoresponder>(
      `${API_BASE_URL}/email/mailboxes/${mailboxId}/autoresponder`,
      { method: 'PUT', body: JSON.stringify(body) },
    );
  },

  remove(mailboxId: number): Promise<void> {
    return fetchAPI<void>(
      `${API_BASE_URL}/email/mailboxes/${mailboxId}/autoresponder`,
      { method: 'DELETE' },
    );
  },
};
